var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bc-access-point-table',{attrs:{"with-url-params":false,"disabled":true,"show-filters":false,"show-ordering":false,"table-fields":_vm.tableFields,"no-checkbox-column":true,"initial-filters":_vm.initialFilters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }